import * as Yup from 'yup';

const RequestCompanySchema = Yup.object({
    companyName: Yup.string().required('Required'),
    companyType: Yup.string().required('Required'),
    country: Yup.string().required('Required'),
    salesManager: Yup.string().required('Required'),
});

const InviteUserSchema = Yup.object({
    inviteeName: Yup.string().required('Person name is required'),
    inviteeEmail: Yup.string().email('Invalid email address').required('Email is required'),
});

export { RequestCompanySchema, InviteUserSchema };
